import React from 'react';
import CatalogImage from './CatalogImage';
import MatchBadge from './MatchBadge';
import { hasPrice } from './price';
import type { ShoppableProduct } from './types';

interface ProductPreviewProps {
  product: ShoppableProduct;
  position?: { left: number; top: number };
  onEnter: () => void;
  onLeave: () => void;
  onOpen: () => void;
  onSimilar: () => void;
}

/** The hover card next to a hotspot: thumbnail, brand, name, and the two ways in. */
const ProductPreview: React.FC<ProductPreviewProps> = ({ product, position, onEnter, onLeave, onOpen, onSimilar }) => (
  <div
    data-silvr-ui="true"
    role="dialog"
    aria-label={`Shop this style: ${product.name}`}
    className="product-preview silvr-ui fixed z-[1200] rounded-2xl border border-black/10 bg-white p-4 text-gray-900 shadow-2xl"
    style={position ? { left: position.left, top: position.top } : undefined}
    onMouseEnter={onEnter}
    onMouseLeave={onLeave}
    onClick={(event) => event.stopPropagation()}
  >
    <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-gray-500">Shop this style</p>
    <div className="flex items-center gap-3">
      <CatalogImage src={product.image} alt={product.name} className="h-20 w-20 shrink-0 rounded-lg bg-gray-100 object-contain" />
      <div className="min-w-0 flex-1">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wide text-gray-500">
          <span className="truncate">{product.brand}</span>
          <MatchBadge matchType={product.matchType} />
        </p>
        <p className="line-clamp-2 text-sm font-medium">{product.name}</p>
        <p className="mt-1 text-sm">{hasPrice(product.price) ? product.price : 'Check retailer for price'}</p>
      </div>
    </div>
    <div className="mt-3 flex gap-2">
      <button type="button" onClick={onOpen} className="min-h-10 flex-1 rounded-full bg-gray-950 px-4 text-sm font-medium text-white">
        View details
      </button>
      {product.similar.length > 0 && (
        <button type="button" onClick={onSimilar} className="min-h-10 rounded-full bg-gray-100 px-4 text-sm font-medium">
          Similar
        </button>
      )}
    </div>
  </div>
);

export default ProductPreview;
